module.exports = __webpack_public_path__ + "static/media/dear-firebase-horizontal-lockup.f0cf6eae.svg";